export type ManualPaymentSlipType =
  | 'federal_retention'
  | 'fiscal_note_slip'
  | 'installment'
  | 'iss_retention'
  | 'other'

export type ManualPaymentSlip = {
  amount: string | number
  due_date: string
  key: string
  month: number | null
  observation: string | null
  other_description: string | null
  paid: boolean
  type: ManualPaymentSlipType
  url: string | null
  year: number | null
}

export const ManualPaymentSlipTypeLabel: Record<ManualPaymentSlipType, string> =
  {
    federal_retention: 'Retenção federal',
    fiscal_note_slip: 'Boleto de nota fiscal',
    installment: 'Parcelamento',
    iss_retention: 'Retenção de ISS',
    other: 'Outros',
  }
